import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { useAuth } from './AuthContext';
import { listExamProfiles, getUserDoc, setSelectedExam } from '../lib/db';

const Ctx = createContext(null);

export function ExamProvider({ children }) {
  const { user } = useAuth();
  const [exams, setExams] = useState([]);
  const [selectedExamId, setSelectedExamId] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    const [profiles, udoc] = await Promise.all([listExamProfiles(), getUserDoc(user.uid)]);
    setExams(profiles.filter((p) => p.active !== false));
    setSelectedExamId(udoc?.selectedExamId ?? null);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    if (user) void load();
    else {
      setExams([]);
      setSelectedExamId(null);
      setLoading(false);
    }
  }, [user, load]);

  const selectExam = useCallback(
    async (examId) => {
      if (!user) return;
      await setSelectedExam(user.uid, examId);
      setSelectedExamId(examId);
    },
    [user],
  );

  const selectedExam = exams.find((e) => e.id === selectedExamId) ?? null;

  return (
    <Ctx.Provider
      value={{ exams, selectedExamId, selectedExam, loading, selectExam, reload: load }}
    >
      {children}
    </Ctx.Provider>
  );
}

export function useExam() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useExam must be used within ExamProvider');
  return ctx;
}
